var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Protocol',{attrs:{"html":_vm.htmlData,"type":"applyMsg","loadingPage":_vm.loadingPage}})}
var staticRenderFns = []

export { render, staticRenderFns }